/* Arrows for the peek carousel.
 *
 * The row scrolls natively, so touch needs nothing from this file -- the arrows
 * exist only for desktop pointers. Each press moves one viewport-width of
 * cards, and the buttons hide at either end rather than sitting there dead.
 */
class PeekCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-peek-track]');
    this.prev = this.querySelector('[data-peek-prev]');
    this.next = this.querySelector('[data-peek-next]');
    if (!this.track || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.scrollByPage(-1));
    this.next.addEventListener('click', () => this.scrollByPage(1));

    this.onScroll = this.updateArrows.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    // The card width depends on the container, so re-check after layout settles
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.onScroll);
      this.observer.observe(this.track);
    }

    this.updateArrows();
  }

  disconnectedCallback() {
    if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    if (this.observer) this.observer.disconnect();
  }

  scrollByPage(direction) {
    const card = this.track.querySelector('.peek-carousel__item');
    // Fall back to the viewport if there are no cards to measure
    const step = card ? card.getBoundingClientRect().width * Math.floor(this.visibleCards()) : this.track.clientWidth;

    this.track.scrollBy({
      left: step * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  visibleCards() {
    const card = this.track.querySelector('.peek-carousel__item');
    if (!card) return 1;
    const width = card.getBoundingClientRect().width;
    return width > 0 ? Math.max(1, this.track.clientWidth / width) : 1;
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const left = this.track.scrollLeft;

    this.prev.disabled = left <= 1;
    // A pixel of slack: fractional card widths rarely land exactly on the end
    this.next.disabled = left >= max - 1;
  }
}

customElements.define('peek-carousel', PeekCarousel);
